<template>
  <layout-view navTitle="Фильтры" :navLoading="loadState.isLoading">
    <template v-slot:widgets>
      <v-row class="rowSmall">
        <v-col>
          <card-view title="Очередь / Обработка / Всего" :loading="loadState.isLoading" minHeight="84">
            <template v-slot:content>
              <h2 v-if="typeof indicators.totalChats!=='undefined'" class="font-weight-medium mb-2">
                {{indicators.totalQueue}} / {{indicators.totalProcess}} / {{indicators.totalChats}}
              </h2>
            </template>
          </card-view>
        </v-col>
        <v-col>
          <card-view title="Закрытые / Рабочие" :loading="loadState.isLoading" minHeight="84">
            <template v-slot:content>
              <h2 v-if="typeof indicators.totalClosed!=='undefined'" class="font-weight-medium mb-2">
                {{indicators.totalClosed}} / {{indicators.totalInternal}}
              </h2>
            </template>
          </card-view>
        </v-col>
        <v-col>
          <card-view title="Проставлено целей / результатов" :loading="loadState.isLoading" minHeight="84">
            <template v-slot:content>
              <v-row v-if="typeof indicators.chatsWithCallTarget!=='undefined'" no-gutters>
                <v-col class="pr-2">
                  <progress-widget
                      :text1="indicators.chatsWithCallTarget+' шт. / '+$tools.percent(indicators.chatsWithCallTarget, indicators.totalChats)"
                      :value="$tools.percent(indicators.chatsWithCallTarget, indicators.totalChats, 0, true)"
                  />
                </v-col>
                <v-col>
                  <progress-widget
                      :text1="indicators.chatsWithCallResult+' шт. / '+$tools.percent(indicators.chatsWithCallResult, indicators.totalChats)"
                      :value="$tools.percent(indicators.chatsWithCallResult, indicators.totalChats, 0, true)"
                  />
                </v-col>
              </v-row>
            </template>
          </card-view>
        </v-col>
        <v-col>
          <card-view title="Конверсия" :loading="loadState.isLoading" tooltip="Конверсия по результату обращения «успешно»" minHeight="84">
            <template v-slot:content>
              <div v-if="typeof indicators.successResultPercent!=='undefined'" class="d-flex justify-center">
                <progress-widget
                    :text1="indicators.successResultPercent+' %'"
                    :value="indicators.successResultPercent"
                />
              </div>
            </template>
          </card-view>
        </v-col>
      </v-row>
    </template>

    <template v-slot:nav>
      <div class="px-4">
        <date-interval name="Интервал" :valueFrom.sync="filter.dateFrom" :valueTo.sync="filter.dateTo"/>

        <date-interval name="Дата события" :valueFrom.sync="filter.eventDateFrom" :valueTo.sync="filter.eventDateTo"/>

        <autocomplete-multiple name="Тип события" :items="eventTypeItems" :select.sync="filter.eventTypes" textOverflow/>

        <autocomplete-multiple name="Категория" :items="cats" :select.sync="filter.cats" textOverflow>
          <template v-slot:itemIcon="{item}">
            <v-icon small class="mr-1" style="margin-top:-3px">{{item.icon}}</v-icon>
          </template>
          <template v-slot:selectedInfo="{item}">
            <v-icon small class="mr-1" style="margin-top:-2px">{{item.icon}}</v-icon> {{item.name}}
          </template>
        </autocomplete-multiple>

        <autocomplete-multiple name="Статус" :items="statuses" :select.sync="filter.statuses" textOverflow>
          <template v-slot:itemIcon="{item}">
            <v-avatar :color="item.color" size="10" class="mr-1" style="margin-top:-3px"/>
          </template>
          <template v-slot:selectedInfo="{item}">
            <v-avatar :color="item.color" size="10" class="mr-1" style="margin-top:-2px"/> {{item.name}}
          </template>
        </autocomplete-multiple>

        <radios
            name="Просмотр"
            :items="[{id:'my',name:'Мои чаты'},{id:'all',name:'Чаты всех пользователей'}]"
            :select.sync="filter.filterView"
        />

        <text-field name="Название чата" :value.sync="filter.name"/>

        <text-field name="Номер телефона" :value.sync="filter.phone"/>

        <autocomplete-multiple name="Канал" :items="providers" :select.sync="filter.providers" textOverflow>
          <template v-slot:itemIcon="{item}">
            <v-avatar :color="item.iconBgColor" size="18" class="mr-1">
              <v-icon color="white" size="12" style="margin-top:1px">{{item.icon}}</v-icon>
            </v-avatar>
          </template>
          <template v-slot:selectedInfo="{item}">
            <v-avatar :color="item.iconBgColor" size="16" class="mr-1">
              <v-icon color="white" size="10">{{item.icon}}</v-icon>
            </v-avatar>
            {{item.name}}
          </template>
        </autocomplete-multiple>

        <user-autocomplete-multiple name="Клиент" :select.sync="filter.users"/>

        <autocomplete-multiple name="Оператор" :items="adminsFiltered" :select.sync="filter.admins">
          <template v-slot:itemInfo="{item}">
            {{$tools.userFullName(item)}}
          </template>
          <template v-slot:selectedInfo="{item}">
            {{$tools.userFullName(item, true)}}
          </template>
        </autocomplete-multiple>

        <autocomplete-multiple name="Цель обращения" :items="callTargets" :select.sync="filter.callTarget" textOverflow selectAllEnabled/>

        <autocomplete-single name="Результат обращения" :items="callResults" :select.sync="filter.callResult" clearable>
          <template v-slot:no-data>
            <div class="caption text-center">Не найдено</div>
          </template>
          <template v-slot:itemIcon="{item}">
            <v-avatar v-if="item.type==='success'" color="success" size="16" class="mr-2"><v-icon color="white" size="12">mdi-check</v-icon></v-avatar>
            <v-avatar v-else-if="item.type==='info'" color="blue" size="16" class="mr-2"><v-icon color="white" size="20">mdi-information-symbol</v-icon></v-avatar>
            <v-avatar v-else color="red" size="16" class="mr-2"><v-icon color="white" size="12">mdi-close</v-icon></v-avatar>
          </template>
          <template v-slot:selectedInfo="{item}">
            <v-avatar v-if="item.type==='success'" color="success" size="16" style="margin-top:-10px" class="mr-2"><v-icon color="white" size="12">mdi-check</v-icon></v-avatar>
            <v-avatar v-else-if="item.type==='info'" color="blue" size="16" style="margin-top:-2px" class="mr-2"><v-icon color="white" size="20">mdi-information-symbol</v-icon></v-avatar>
            <v-avatar v-else color="red" size="16" class="mr-2"><v-icon color="white" size="12">mdi-close</v-icon></v-avatar>
            <span class="text-no-wrap">{{item.name}}</span>
          </template>
        </autocomplete-single>
      </div>
    </template>

    <template v-slot:content="{height}">
      <n-table-view
          ref="table"
          name="Реестр чатов"
          :genRequestBuilder="genRequestBuilder"
          :height="height"
          :headers="[
            { text: 'ID', value: 'id', class:'text-no-wrap'},
            { text: 'Дата последнего сообщения', value: 'dialogMesLast.created', class:'text-no-wrap' },
            { text: 'Дата последнего события', value: 'dialogMesLastEvent.created', class:'text-no-wrap', sortable:false },
            { text: 'Последнее событие', value: 'dialogMesLastEvent.eventType', class:'text-no-wrap', sortable:false },
            { text: 'Категория', value: 'cat', class:'text-no-wrap' },
            { text: 'Статус', value: 'status', class:'text-no-wrap' },
            { text: 'Название', value: 'name', class:'text-no-wrap' },
            { text: 'Клиент', value: 'client', class:'text-no-wrap', sortable:false },
            { text: 'Оператор', value: 'operator', class:'text-no-wrap', sortable:false },
            { text: 'Канал', value: 'provider', class:'text-no-wrap', sortable:false },
            { text: 'Цель', value: 'callTarget', class:'text-no-wrap'},
            { text: 'Результат', value: 'callResult', class:'text-no-wrap' },
            { text: 'Текст последнего сообщения', value: 'dialogMesLast.text', class:'text-no-wrap', sortable:false },
          ]"
          table-class="table9"
          autoUpdate
      >
        <template v-slot:item="{item}">
          <tr @click="openChat(item)" :key="'dc_'+item.id" class="clickable">
            <td>{{item.id}}</td>
            <td>{{item.dialogMesLast ? $tools.dateTimeFormat(item.dialogMesLast.created,'DD.MM.YYYY HH:mm') : ''}}</td>
            <td>{{item.dialogMesLastEvent ? $tools.dateTimeFormat(item.dialogMesLastEvent.created,'DD.MM.YYYY HH:mm') : ''}}</td>
            <td>
              <template v-if="item.dialogMesLastEvent">
                <span>{{eventTypeName(item.dialogMesLastEvent.eventType)}}</span>
                <v-btn icon x-small class="ml-1" @click.stop="openEventsHistory(item)">
                  <v-icon small>mdi-history</v-icon>
                </v-btn>
              </template>
            </td>
            <td>
              <v-icon v-if="catItem(item.cat)" small class="mr-1">{{catItem(item.cat).icon}}</v-icon>
              {{catItem(item.cat) ? catItem(item.cat).name : item.cat}}
            </td>
            <td>
              <v-avatar v-if="statusItem(item.status)" :color="statusItem(item.status).color" size="10" class="mr-1" style="margin-top:-2px"/>
              {{statusItem(item.status) ? statusItem(item.status).name : item.status}}
            </td>
            <td>{{chatDisplayName(item)}}</td>
            <td>
              <user-full-name v-if="clientUser(item)" :user="clientUser(item)"/>
              <span v-else-if="clientDialogUser(item)">{{clientDialogUser(item).name}}</span>
            </td>
            <td>
              <user-full-name v-if="operatorUser(item)" :user="operatorUser(item)" short/>
            </td>
            <td>{{clientDialogUser(item) ? $tools.dialogProviderName(clientDialogUser(item).provider) : ''}}</td>
            <td>
              <div v-if="item.callTarget">{{item.callTarget.name}}</div>
            </td>
            <td>
              <div v-if="item.callResult">
                <v-avatar v-if="item.callResult.type==='success'" color="success" size="16" style="margin-top:-2px" class="mr-1"><v-icon color="white" size="12">mdi-check</v-icon></v-avatar>
                <v-avatar v-else-if="item.callResult.type==='info'" color="blue" size="16" style="margin-top:-2px" class="mr-1"><v-icon color="white" size="20">mdi-information-symbol</v-icon></v-avatar>
                <v-avatar v-else color="red" size="16" style="margin-top:-2px" class="mr-1"><v-icon color="white" size="12">mdi-close</v-icon></v-avatar>
                {{item.callResult.name}}
              </div>
            </td>
            <td>
              <span v-if="item.dialogMesLast" class="text-no-wrap">{{item.dialogMesLast.text}}</span>
            </td>
          </tr>
        </template>
      </n-table-view>
      <dialog-editor
          :color="$mainColor"
          :item.sync="selectedChat"
          :name="selectedChat ? selectedChat._name : 'Чат'"
          width="700"
          fixed-height
          content-padding-remove
          :footer-hide="false"
          :submit-text="null"
          disable-overlay-click
      >
        <template v-slot:default="{localItem, height}">
          <dialog-page-chat
              v-if="localItem"
              :height="height"
              :cats="cats"
              :chat="localItem"
              :messageTemplates="[]"
              @close="selectedChat=null"
          />
        </template>
      </dialog-editor>

      <dialog-editor
          :color="$mainColor"
          :item.sync="eventsHistoryChat"
          :name="eventsHistoryChat ? 'История событий — ' + eventsHistoryChat._name : 'История событий'"
          width="700"
          :footer-hide="false"
          :submit-text="null"
      >
        <template v-slot:default>
          <div v-if="eventsHistoryLoading" class="text-center py-8">
            <v-progress-circular indeterminate color="primary"/>
          </div>
          <div v-else-if="eventsHistoryItems.length === 0" class="pa-4">
            <alert>События не найдены</alert>
          </div>
          <v-simple-table class="mb-3" v-else dense>
            <thead>
              <tr>
                <th>Дата</th>
                <th>Тип</th>
                <th>Описание</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="ev in eventsHistoryItems" :key="'ev_'+ev.id">
                <td class="text-no-wrap">{{$tools.dateTimeFormat(ev.created,'DD.MM.YYYY HH:mm')}}</td>
                <td class="text-no-wrap">{{eventTypeName(ev.eventType)}}</td>
                <td>{{ev.text}}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </template>
      </dialog-editor>
    </template>
  </layout-view>
</template>

<script>
import moment from "moment";
import axios from "axios";
import State from "@/plugins/state";
import LayoutView from "@/components/LayoutView.vue";
import CardView from "@/components/CardView.vue";
import NTableView from "@/componentsV2/base/NTableView.vue";
import DateInterval from "@/componentsV2/base/DateInterval.vue";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import UserAutocompleteMultiple from "@/componentsV2/custom/UserAutocompleteMultiple.vue";
import TextField from "@/componentsV2/base/TextField.vue";
import Radios from "@/componentsV2/base/Radios.vue";
import ProgressWidget from "@/componentsV2/base/ProgressWidget.vue";
import DialogEditor from "@/componentsV2/base/DialogEditor.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import DialogPageChat from "./components/DialogPageChat.vue";
import Alert from "@/componentsV2/base/Alert.vue";
import {
  Entity_CallResult,
  Entity_CallTarget,
  Entity_DialogChat,
  Entity_DialogMessage,
  Entity_DialogUser,
  Entity_User,
  Entity_UserProfile,
} from "../../../../EntityStoreCacheService";

export default {
  components: {
    DialogPageChat,
    DialogEditor,
    UserFullName,
    ProgressWidget,
    Radios,
    TextField,
    UserAutocompleteMultiple,
    AutocompleteSingle,
    AutocompleteMultiple,
    DateInterval,
    NTableView,
    LayoutView,
    CardView,
    Alert,
  },
  props: ['callTargets', 'callResults'],
  data: () => ({
    loadState: new State(),
    filter: {},
    filterStorageKey: 'dialogChatsFilter?v3',
    baseFilter: {
      dateFrom: moment().format('DD.MM.YYYY'),
      dateTo: moment().format('DD.MM.YYYY'),
      eventDateFrom: null,
      eventDateTo: null,
      eventTypes: [],
      cats: [],
      statuses: [],
      name: null,
      phone: null,
      filterView: {id: 'all', name: 'Чаты всех пользователей'},
      users: [],
      admins: [],
      providers: [],
      callTarget: [],
      callResult: null,
    },
    cats: [
      {id: 'internal', name: 'Рабочий', icon: 'mdi-account-tie'},
      {id: 'queue', name: 'Очередь', icon: 'mdi-account-question'},
      {id: 'process', name: 'Обработка', icon: 'mdi-account-clock'},
      {id: 'closed', name: 'Закрытые', icon: 'mdi-account-remove'},
    ],
    statuses: [
      {name: 'Активный', id: 'active', color: '#02924d'},
      {name: 'Неактивный', id: 'unactive', color: '#607D8B'},
    ],
    providers: [],
    admins: [],
    adminsFiltered: [],
    indicators: {},
    selectedChat: null,
    eventsHistoryChat: null,
    eventsHistoryItems: [],
    eventsHistoryLoading: false,
    eventTypeItems: [
      {id: 'cat', name: 'Категория чата'},
      {id: 'userJoin', name: 'Присоединение к чату'},
      {id: 'userLeave', name: 'Покинул чат'},
      {id: 'userClient', name: 'Назначен клиент МИС'},
      {id: 'callTarget', name: 'Цель обращения'},
      {id: 'callResult', name: 'Результат обращения'},
    ],
  }),
  mounted() {
    this.filter = this.$tools.storageGet(this.filterStorageKey, this.$tools.copy(this.baseFilter));
    this.adminsLoad();
    this.providersLoad();
  },
  watch: {
    filter: {
      handler() {
        this.$tools.storageSet(this.filterStorageKey, this.filter);
        if (this.$refs.table)
          this.$refs.table.load();
      },
      deep: true,
    },
  },
  methods: {
    applyEventFilters(rb) {
      const hasEventDate = !this.$tools.isEmpty(this.filter.eventDateFrom) || !this.$tools.isEmpty(this.filter.eventDateTo);
      const hasEventTypes = this.filter.eventTypes.length > 0;
      if (!hasEventDate && !hasEventTypes)
        return;

      rb.filterAnd([Entity_DialogChat.entity, Entity_DialogChat.dialogMessages, Entity_DialogMessage.eventType].join('.') + ' IS NOT NULL');

      if (!this.$tools.isEmpty(this.filter.eventDateFrom))
        rb.filterAnd([Entity_DialogChat.entity, Entity_DialogChat.dialogMessages, Entity_DialogMessage.created].join('.') + '>=?', moment(this.filter.eventDateFrom, 'DD.MM.YYYY').format('YYYY-MM-DD 00:00:00'));
      if (!this.$tools.isEmpty(this.filter.eventDateTo))
        rb.filterAnd([Entity_DialogChat.entity, Entity_DialogChat.dialogMessages, Entity_DialogMessage.created].join('.') + '<=?', moment(this.filter.eventDateTo, 'DD.MM.YYYY').format('YYYY-MM-DD 23:59:59'));
      if (hasEventTypes)
        rb.filterAnd([Entity_DialogChat.entity, Entity_DialogChat.dialogMessages, Entity_DialogMessage.eventType].join('.') + ' in (?)', this.queryArray(this.filter.eventTypes));
    },
    eventTypeName(type) {
      const item = this.eventTypeItems.find(v => v.id === type);
      return item ? item.name : type;
    },
    providersLoad() {
      axios.get('/napi/dialog/provider/')
          .then(r => {
            this.providers = r.data;
          });
    },
    adminsLoad() {
      new Entity_User()
          .selects(Entity_User.id)
          .selects(Entity_User.firstName)
          .selects(Entity_User.lastName)
          .selects(Entity_User.secondName)
          .selects(Entity_User.imageUrl)
          .selects(Entity_User.type)
          .filterAnd([Entity_User.entity, Entity_User.type].join('.') + ' =?', 'admin')
          .page(1).onPage(10000)
          .request((data) => {
            this.admins = data.items;
            this.adminsFiltered = data.items;
          });
    },
    genRequestBuilder(page, onPage, sortFields) {
      let rb = new Entity_DialogChat()
          .selects(Entity_DialogChat.id)
          .selects(Entity_DialogChat.cat)
          .selects(Entity_DialogChat.status)
          .selects(Entity_DialogChat.name)

          .selects([Entity_DialogChat.callTarget, Entity_CallTarget.id].join('.'))
          .selects([Entity_DialogChat.callTarget, Entity_CallTarget.name].join('.'))

          .selects([Entity_DialogChat.callResult, Entity_CallResult.id].join('.'))
          .selects([Entity_DialogChat.callResult, Entity_CallResult.name].join('.'))
          .selects([Entity_DialogChat.callResult, Entity_CallResult.type].join('.'))

          .selects([Entity_DialogChat.dialogMesLast, Entity_DialogMessage.id].join('.'))
          .selects([Entity_DialogChat.dialogMesLast, Entity_DialogMessage.created].join('.'))
          .selects([Entity_DialogChat.dialogMesLast, Entity_DialogMessage.text].join('.'))
          .selects([Entity_DialogChat.dialogMesLast, Entity_DialogMessage.type].join('.'))

          .selects([Entity_DialogChat.dialogUsers, Entity_DialogUser.id].join('.'))
          .selects([Entity_DialogChat.dialogUsers, Entity_DialogUser.name].join('.'))
          .selects([Entity_DialogChat.dialogUsers, Entity_DialogUser.phone].join('.'))
          .selects([Entity_DialogChat.dialogUsers, Entity_DialogUser.provider].join('.'))
          .selects([Entity_DialogChat.dialogUsers, Entity_DialogUser.user, Entity_User.id].join('.'))
          .selects([Entity_DialogChat.dialogUsers, Entity_DialogUser.user, Entity_User.type].join('.'))
          .selects([Entity_DialogChat.dialogUsers, Entity_DialogUser.user, Entity_User.firstName].join('.'))
          .selects([Entity_DialogChat.dialogUsers, Entity_DialogUser.user, Entity_User.lastName].join('.'))
          .selects([Entity_DialogChat.dialogUsers, Entity_DialogUser.user, Entity_User.secondName].join('.'))
          .selects([Entity_DialogChat.dialogUsers, Entity_DialogUser.user, Entity_User.phone].join('.'))
          .selects([Entity_DialogChat.dialogUsers, Entity_DialogUser.user, Entity_User.userProfile, Entity_UserProfile.gender].join('.'))
          .selects([Entity_DialogChat.dialogUsers, Entity_DialogUser.user, Entity_User.userProfile, Entity_UserProfile.birth].join('.'))

          .virtual(Entity_DialogChat.virtual_dialogMesLastEvent)
          .collect(Entity_DialogChat.collect_indicators)

      rb.page(page).onPage(onPage);

      if (this.filter.dateFrom)
        rb.filterAnd([Entity_DialogChat.entity, Entity_DialogChat.dialogMesLast, Entity_DialogMessage.created].join('.') + '>=?', moment(this.filter.dateFrom, 'DD.MM.YYYY').format('YYYY-MM-DD 00:00:00'));
      if (this.filter.dateTo)
        rb.filterAnd([Entity_DialogChat.entity, Entity_DialogChat.dialogMesLast, Entity_DialogMessage.created].join('.') + '<=?', moment(this.filter.dateTo, 'DD.MM.YYYY').format('YYYY-MM-DD 23:59:59'));

      this.applyEventFilters(rb);

      if (this.filter.cats.length > 0)
        rb.filterAnd([Entity_DialogChat.entity, Entity_DialogChat.cat].join('.') + ' in (?)', this.queryArray(this.filter.cats));

      if (this.filter.statuses.length > 0)
        rb.filterAnd([Entity_DialogChat.entity, Entity_DialogChat.status].join('.') + ' in (?)', this.queryArray(this.filter.statuses));

      if (this.filter.filterView?.id === 'my' && this.$store.state.user)
        rb.filterAnd([Entity_DialogChat.entity, Entity_DialogChat.dialogUsers, Entity_DialogUser.user, Entity_User.id].join('.') + '=?', this.$store.state.user.id);

      if (!this.$tools.isEmpty(this.filter.name))
        rb.filterAnd([Entity_DialogChat.entity, Entity_DialogChat.name].join('.') + ' LIKE ?', '%' + this.filter.name + '%');

      if (!this.$tools.isEmpty(this.filter.phone)) {
        const v = this.$tools.phoneFormat(this.filter.phone, true, true);
        const phones = [v, v.slice(1), '8' + v.slice(1), '7' + v.slice(1)];
        rb.filterAnd(
            [Entity_DialogChat.entity, Entity_DialogChat.dialogUsers, Entity_DialogUser.phone].join('.') + ' in (?) OR ' +
            [Entity_DialogChat.entity, Entity_DialogChat.dialogUsers, Entity_DialogUser.user, Entity_User.phone].join('.') + ' in (?)',
            phones,
            phones
        );
      }

      if (this.filter.providers.length > 0)
        rb.filterAnd([Entity_DialogChat.entity, Entity_DialogChat.dialogUsers, Entity_DialogUser.provider].join('.') + ' in (?)', this.queryArray(this.filter.providers));

      if (this.filter.users.length > 0 || this.filter.admins.length > 0) {
        const users = this.filter.users.map(v => v.id);
        const admins = this.filter.admins.map(v => v.id);
        const arr = users.concat(admins);
        rb.filterAnd(
            [Entity_DialogChat.entity, Entity_DialogChat.dialogUsers, Entity_DialogUser.user, Entity_User.id].join('.') + ' in (?)',
            arr.join(',')
        );
      }

      if (this.filter.callTarget !== null && this.filter.callTarget.length > 0)
        rb.filterAnd([Entity_DialogChat.entity, Entity_DialogChat.callTarget, Entity_CallTarget.id].join('.') + ' in (?)', this.queryArray(this.filter.callTarget));

      if (this.filter.callResult)
        rb.filterAnd([Entity_DialogChat.entity, Entity_DialogChat.callResult, Entity_CallResult.id].join('.') + '=?', this.filter.callResult.id);

      rb.addStateCallback((v) => {
        this.loadState.setRequestBuilderState(v);
        if (v.success)
          this.indicators = v.collect.indicators || {};
      });

      if (sortFields.length === 0) {
        rb.order([Entity_DialogChat.dialogMesLast, Entity_DialogMessage.created].join('.'), false);
      } else {
        sortFields.forEach(v => rb.order(v.field, v.isAsc));
      }

      return rb;
    },
    queryArray(items, key = 'id') {
      const arr = [];
      items.forEach(s => arr.push(s[key]));
      return arr;
    },
    catItem(cat) {
      return this.cats.find(v => v.id === cat) || null;
    },
    statusItem(status) {
      return this.statuses.find(v => v.id === status) || null;
    },
    clientDialogUser(item) {
      const userId = this.$store.state.user?.id;
      const arr = (item.dialogUsers || [])
          .filter(v => v.provider !== 'internal')
          .filter(v => v.user === null || v.user.id !== userId);
      return arr.length > 0 ? arr[0] : null;
    },
    clientUser(item) {
      const du = this.clientDialogUser(item);
      return du?.user || null;
    },
    operatorUser(item) {
      const arr = (item.dialogUsers || [])
          .filter(v => v.user !== null && v.user.type !== 'client');
      return arr.length > 0 ? arr[0].user : null;
    },
    chatDisplayName(item) {
      const userId = this.$store.state.user?.id;
      const userNames = [];
      (item.dialogUsers || []).forEach(u => {
        if (u.user === null)
          userNames.push(u.name);
        else if (u.user.id !== userId)
          userNames.push(this.$tools.userFullName(u.user, true));
      });
      let name = this.$tools.isEmpty(item.name) ? 'Без имени' : item.name;
      const nameFromUsers = userNames.join(',');
      if (nameFromUsers) {
        if ((item.dialogUsers || []).length === 2)
          name = nameFromUsers;
      }
      if (item.cat !== 'internal')
        name = nameFromUsers || name;
      return name;
    },
    itemToChat(item) {
      const chat = this.$tools.copy(item);
      chat._name = this.chatDisplayName(item);
      return chat;
    },
    openChat(item) {
      this.selectedChat = this.itemToChat(item);
    },
    openEventsHistory(item) {
      this.eventsHistoryChat = {id: item.id, _name: this.chatDisplayName(item)};
      this.eventsHistoryLoad(item.id);
    },
    eventsHistoryLoad(chatId) {
      this.eventsHistoryLoading = true;
      this.eventsHistoryItems = [];
      new Entity_DialogMessage()
          .selects(Entity_DialogMessage.id)
          .selects(Entity_DialogMessage.created)
          .selects(Entity_DialogMessage.eventType)
          .selects(Entity_DialogMessage.eventValue)
          .selects(Entity_DialogMessage.text)
          .filterAnd([Entity_DialogMessage.entity, Entity_DialogMessage.dialogChat, Entity_DialogChat.id].join('.') + '=?', chatId)
          .filterAnd([Entity_DialogMessage.entity, Entity_DialogMessage.eventType].join('.') + ' IS NOT NULL')
          .order(Entity_DialogMessage.created, false)
          .page(1).onPage(10000)
          .request((data) => {
            this.eventsHistoryItems = data.items;
            this.eventsHistoryLoading = false;
          }, () => {
            this.eventsHistoryLoading = false;
          });
    },
  },
}
</script>
